export function getRegionStats(progress: any) {
  if (!progress) return { lowConfCount: 0, errorCount: 0, errorSubCount: 0, message: '', total: 0, finished: 0 };
  const lowConfCount = Array.isArray(progress.lowConfRegions) ? progress.lowConfRegions.length : 0;
  const errorCount = Array.isArray(progress.errorRegions) ? progress.errorRegions.length : 0;
  const errorSubCount = Array.isArray(progress.errorSubmissions) ? progress.errorSubmissions.length : 0;
  const message = typeof progress.message === 'string' ? progress.message : '';
  const total = typeof progress.total === 'number' ? progress.total : 0;
  // Which units are done, same as `getSolutionStats` below — the counter these steps used to keep could not
  // survive a re-upload or a retry of something that had already succeeded. See `finishedUnits`.
  const finished = Array.isArray(progress.finishedUnits) ? progress.finishedUnits.length : 0;
  return { lowConfCount, errorCount, errorSubCount, message, total, finished };
}

/**
 * Stats of a master solution's or grading scheme's single progress state — extraction and generation both
 * write it, so there is one reader. Done-ness is the number of task keys in `createdForTasks`; regions
 * only ever come from an extraction and are simply empty for a generation.
 */
export function getSolutionStats(progress: any) {
  if (!progress) return { lowConfCount: 0, errorCount: 0, errorSubCount: 0, message: '', total: 0, finished: 0 };
  const lowConfCount = Array.isArray(progress.lowConfRegions) ? progress.lowConfRegions.length : 0;
  const errorCount = Array.isArray(progress.errorRegions) ? progress.errorRegions.length : 0;
  const message = typeof progress.message === 'string' ? progress.message : '';
  const total = typeof progress.total === 'number' ? progress.total : 0;
  const finished = Array.isArray(progress.createdForTasks) ? progress.createdForTasks.length : 0;
  return { lowConfCount, errorCount, errorSubCount: 0, message, total, finished };
}

export function getGradingStats(progress: any) {
  if (!progress) return { lowConfCount: 0, errorCount: 0, errorSubCount: 0, message: '', total: 0, finished: 0 };
  const lowConfCount = 0;
  const errorCount = 0;
  const errorSubCount = 0;
  const message = typeof progress.message === 'string' ? progress.message : '';
  const total = typeof progress.total === 'number' ? progress.total : 0;
  // One unit per graded (submission, main task) — the same set shape the other three stats read.
  const finished = Array.isArray(progress.finishedUnits) ? progress.finishedUnits.length : 0;
  return { lowConfCount, errorCount, errorSubCount, message, total, finished };
}

export function unwrapDoc(obj: any): any {
  if (obj && typeof obj === 'object') {
    if (Object.hasOwn(obj, 'doc')) {
      return unwrapDoc(obj.doc);
    }
    for (const key in obj) {
      if (Object.hasOwn(obj, key)) {
        obj[key] = unwrapDoc(obj[key]);
      }
    }
  }
  return obj;
}
